import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {
  fetchEmailStats, fetchDomainAuth, fetchEmailThreats, fetchEmailFindings, fetchRemediations,
  updateFindingStatus, requestRemediation, approveRemediation,
} from '../../services/api/emailService';

export const loadEmailSecurity = createAsyncThunk('email/load', async () => {
  const [stats, domains, threats, findings, remediations] = await Promise.all([
    fetchEmailStats(), fetchDomainAuth(), fetchEmailThreats(), fetchEmailFindings(), fetchRemediations(),
  ]);
  return { stats, domains, threats, findings, remediations };
});

export const setFindingStatus = createAsyncThunk('email/setFindingStatus', async ({ id, status }) => {
  await updateFindingStatus(id, status);
  return fetchEmailFindings();
});

export const submitRemediation = createAsyncThunk('email/submitRemediation', async (payload) => {
  await requestRemediation(payload);
  return fetchRemediations();
});

export const approveRemediationRequest = createAsyncThunk('email/approveRemediation', async (id) => {
  await approveRemediation(id);
  return fetchRemediations();
});

const emailSlice = createSlice({
  name: 'email',
  initialState: { status: 'idle', error: null, stats: null, domains: [], threats: [], findings: [], remediations: [] },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loadEmailSecurity.pending, (state) => { state.status = 'loading'; })
      .addCase(loadEmailSecurity.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.stats = action.payload.stats;
        state.domains = action.payload.domains;
        state.threats = action.payload.threats;
        state.findings = action.payload.findings;
        state.remediations = action.payload.remediations;
      })
      .addCase(loadEmailSecurity.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })
      .addCase(setFindingStatus.fulfilled, (state, action) => { state.findings = action.payload; })
      .addCase(submitRemediation.fulfilled, (state, action) => { state.remediations = action.payload; })
      .addCase(approveRemediationRequest.fulfilled, (state, action) => { state.remediations = action.payload; });
  }
});

export default emailSlice.reducer;
